import { render, staticRenderFns } from "./BrandIdentity.vue?vue&type=template&id=641b4a1d&"
import script from "./BrandIdentity.vue?vue&type=script&lang=ts&"
export * from "./BrandIdentity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports